import {m, Theme} from '../n2/components/base.js'
import theme from '../shared/theme.js'
import {BasicFrame} from '../shared/components/frames.js'
import {LoginPage} from '../shared/components/userPages.js'
import User from '../shared/state/User.js'
import DataSource from '../n2/data/DataSource.js'

Theme.init(theme)

const user = new User(new DataSource('/data/users', true))

m.mount(document.body, {
    view: (vnode) => m(BasicFrame, {
        backgroundSrc: '/assets/background-login-low.png'
    }, m(LoginPage, { user, next: () => window.location.reload() }))
})
